import instance from './request'
import bankInstance from './bankRequest'

export const getData = (params) => instance.post('/pay/body',params,'application/json')
export const getDetail = (params) => instance.post('/pay/request',params,'application/json')
export const getDedata = (params) => instance.post('/pay/debody',params,'')
export const upData = (params) => bankInstance.post('/bhdep/payTransactionNew',params)

// 获取七牛上传凭证（请在网关侧实现该接口，返回 { token } 或 { uptoken }）
export const getQiniuToken = () => instance.get('/upload/qiniu/token')


